import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProductDrum from '@/pages/home/components/ProductDrum';

const products = [
  {
    id: 1,
    name: 'ALPHA-29',
    fullName: 'Demulsificante para Separación de Emulsiones',
    category: 'Tratamiento de Crudo',
    description: 'Agente químico especializado para la separación de emulsiones de petróleo y agua, facilitando una mayor eficiencia en la producción, el procesamiento en refinerías y la clarificación del petróleo crudo.',
    specs: ['Separación rápida', 'Alta eficiencia', 'Uso en refinerías', 'Clarificación de crudo'],
    image: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/46c578258131142314943d7342e85be1.jpeg',
    badge: 'Alta Demanda',
    badgeColor: 'bg-accent-500',
    stockDrum: 180,
    stockTote: 45,
  },
  {
    id: 2,
    name: 'ANTIESPUMANTE ALPHAS-28',
    fullName: 'Antiespumante para Crudo y Procesos',
    category: 'Tratamiento de Crudo',
    description: 'Formulación avanzada para el control y reducción de la formación de espuma en pozos, tanques de almacenamiento, transporte, procesos de refinería y tratamiento de aguas residuales de la industria petrolera.',
    specs: ['Control de espuma', 'Pozos y tanques', 'Transporte de crudo', 'Refinerías y aguas'],
    image: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/bc7f72f3c7c6681cd53f904e3ee7f778.jpeg',
    badge: null,
    badgeColor: '',
    stockDrum: 45,
    stockTote: 12,
  },
  {
    id: 3,
    name: 'SECUESTRANTE DE OXÍGENO ALPHA-42',
    fullName: 'Secuestrante de Oxígeno para Protección de Equipos',
    category: 'Inhibidores y Protectores',
    description: 'Aditivo químico especializado para la eliminación de oxígeno disuelto, protegiendo contra la corrosión en tuberías y equipos de perforación, previniendo la formación de espuma y evitando la degradación de combustibles.',
    specs: ['Eliminación de O₂', 'Anticorrosivo', 'Protección de tuberías', 'Estabilidad de combustibles'],
    image: 'https://readdy.ai/api/search-image?query=Industrial%20oxygen%20scavenger%20chemical%20product%20in%20professional%20packaging%2C%20sulfite%20based%20corrosion%20protection%20additive%20for%20oilfield%20drilling%20equipment%20and%20pipelines%2C%20clean%20neutral%20white%20background%20studio%20lighting%2C%20professional%20chemical%20industry%20supply%20product%20photography&width=600&height=450&seq=prod-alpha42-03&orientation=landscape',
    badge: 'Protección Avanzada',
    badgeColor: 'bg-primary-500',
    stockDrum: 75,
    stockTote: 20,
  },
  {
    id: 4,
    name: 'NIVELADOR DE pH ALPHA',
    fullName: 'Regulador de pH para Fluidos de Perforación',
    category: 'Control de Fluidos',
    description: 'Formulación precisa para ajustar y mantener el pH óptimo en fluidos de perforación y procesos industriales, previniendo la corrosión, la formación de depósitos minerales (escala) y reduciendo emulsiones no deseadas.',
    specs: ['Ajuste de pH preciso', 'Prevención de corrosión', 'Control de escala', 'Reducción de emulsiones'],
    image: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/3402b7a8525f0e33e52ff7c50674d5df.jpeg',
    badge: null,
    badgeColor: '',
    stockDrum: 220,
    stockTote: 55,
  },
  {
    id: 5,
    name: 'BIOCIDA ALPHA-46',
    fullName: 'Biocida de Amplio Espectro para Sistemas Petroleros',
    category: 'Control de Fluidos',
    description: 'Agente biocida de amplio espectro para el control y la eliminación de bacterias, hongos y algas en sistemas de producción y transporte de petróleo, previniendo la obstrucción de equipos y la degradación de fluidos.',
    specs: ['Amplio espectro', 'Control bacteriano', 'Antihongos y algas', 'Protección de equipos'],
    image: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/6d0e5ff686a9f7ee9eac4dcd6088e7f6.jpeg',
    badge: 'Alto Rendimiento',
    badgeColor: 'bg-accent-500',
    stockDrum: 12,
    stockTote: 4,
  },
  {
    id: 6,
    name: 'INHIBIDOR DE CORROSIÓN ALPHA-43',
    fullName: 'Inhibidor de Corrosión para Superficies Metálicas',
    category: 'Inhibidores y Protectores',
    description: 'Compuesto químico formador de película protectora para superficies metálicas en tuberías, equipos de perforación y tanques de almacenamiento, impidiendo eficazmente el contacto con elementos corrosivos y prolongando la vida útil de los activos.',
    specs: ['Capa protectora', 'Tuberías y equipos', 'Tanques de almacenamiento', 'Larga duración'],
    image: 'https://readdy.ai/api/search-image?query=Industrial%20corrosion%20inhibitor%20chemical%20product%20in%20professional%20packaging%2C%20film-forming%20amine%20based%20metal%20surface%20protection%20for%20oilfield%20pipelines%20and%20storage%20tanks%2C%20clean%20white%20studio%20background%20with%20soft%20edges%2C%20professional%20chemical%20industry%20commercial%20product%20photography&width=600&height=450&seq=prod-alpha43-06&orientation=landscape',
    badge: 'Esencial',
    badgeColor: 'bg-primary-500',
    stockDrum: 60,
    stockTote: 18,
  },
  {
    id: 7,
    name: 'INHIBIDOR DE INCRUSTACIÓN ALPHA-44',
    fullName: 'Inhibidor de Incrustación y Control de Escala',
    category: 'Inhibidores y Protectores',
    description: 'Formulación avanzada para prevenir la acumulación de minerales y la formación de escala en tuberías, equipos de producción, sistemas de tratamiento de agua, calentadores y calderas, garantizando eficiencia operativa continua.',
    specs: ['Antiescala mineral', 'Tuberías y equipos', 'Calentadores y calderas', 'Tratamiento de agua'],
    image: 'https://readdy.ai/api/search-image?query=Industrial%20scale%20inhibitor%20chemical%20product%20in%20professional%20packaging%2C%20phosphonate%20based%20antiscalant%20for%20oilfield%20production%20equipment%20and%20water%20treatment%20systems%2C%20clean%20white%20studio%20background%20with%20precise%20lighting%2C%20professional%20chemical%20industry%20commercial%20product%20photography&width=600&height=450&seq=prod-alpha44-07&orientation=landscape',
    badge: 'Máxima Eficiencia',
    badgeColor: 'bg-accent-500',
    stockDrum: 35,
    stockTote: 10,
  },
  {
    id: 8,
    name: 'CLARIFICANTE DE AGUA ALPHA-41',
    fullName: 'Clarificante para Tratamiento de Aguas Residuales',
    category: 'Tratamiento de Agua',
    description: 'Agente clarificante de alta efectividad para el tratamiento de aguas residuales y turbias, diseñado para eliminar sólidos suspendidos y reducir la turbiedad mediante una rápida sedimentación, mejorando significativamente la calidad del agua tratada.',
    specs: ['Eliminación de sólidos', 'Sedimentación rápida', 'Reducción de turbiedad', 'Mejora calidad del agua'],
    image: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/6b45d024c7fa3fe51e4dafb6c1b44ebf.jpeg',
    badge: null,
    badgeColor: '',
    stockDrum: 150,
    stockTote: 38,
  },
];

const categories = ['Todos', 'Tratamiento de Crudo', 'Inhibidores y Protectores', 'Control de Fluidos', 'Tratamiento de Agua'];

export default function Products() {
  const [visible, setVisible] = useState(false);
  const [activeCategory, setActiveCategory] = useState('Todos');
  const [hoveredId, setHoveredId] = useState<number | null>(null);
  const navigate = useNavigate();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const filtered = activeCategory === 'Todos'
    ? products
    : products.filter((p) => p.category === activeCategory);

  return (
    <section id="productos" ref={ref} className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className={`text-center mb-12 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="text-primary-500 text-sm font-600 tracking-widest uppercase mb-3 block">
            Área de Perforación
          </span>
          <h2 className="font-heading font-700 text-4xl md:text-5xl text-foreground-950 leading-tight mb-4">
            Productos <span className="gradient-text">Químicos</span>
          </h2>
          <div className="section-divider mx-auto mb-6"></div>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            Línea especializada de aditivos y tratamientos químicos para la industria petrolera, 
            diseñados para optimizar cada fase de perforación, producción y procesamiento.
          </p>
        </div>

        {/* Category filter */}
        <div className={`flex flex-wrap justify-center gap-2 mb-10 transition-all duration-700 delay-100 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-2 rounded-full text-sm font-500 transition-all duration-200 cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:text-foreground-900 border border-background-300 hover:border-primary-300'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Products grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((product, i) => (
            <div
              key={product.id}
              onMouseEnter={() => setHoveredId(product.id)}
              onMouseLeave={() => setHoveredId(null)}
              className={`relative rounded-xl overflow-hidden bg-white border cursor-pointer card-hover transition-all duration-700 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              } ${hoveredId === product.id ? 'border-primary-400' : 'border-background-200'}`}
              style={{ transitionDelay: `${i * 0.08 + 0.2}s` }}
            >
              {/* Badge */}
              {product.badge && (
                <div className={`absolute top-3 left-3 z-10 px-3 py-1 rounded-full text-white text-xs font-600 ${product.badgeColor}`}>
                  {product.badge}
                </div>
              )}

              {/* Drum visual */}
              <div className="relative h-52 overflow-hidden">
                <ProductDrum name={product.name} category={product.category} />
              </div>

              {/* Content */}
              <div className="p-5">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <span className="text-primary-500 text-xs font-600 tracking-wide uppercase block mb-1">
                      {product.category}
                    </span>
                    <h3 className="font-heading font-700 text-xl text-foreground-950">{product.name}</h3>
                    <p className="text-foreground-500 text-xs mt-0.5">{product.fullName}</p>
                  </div>
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                    <i className="ri-flask-line text-primary-400 text-lg"></i>
                  </div>
                </div>

                <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                  {product.description}
                </p>

                {/* Specs */}
                <div className="grid grid-cols-2 gap-2 mb-4">
                  {product.specs.map((spec) => (
                    <div key={spec} className="flex items-center gap-1.5">
                      <div className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0"></div>
                      <span className="text-foreground-600 text-xs">{spec}</span>
                    </div>
                  ))}
                </div>

                {/* Stock availability — two presentations */}
                <div className="flex flex-col gap-1.5 mb-4 px-3 py-2.5 rounded-lg bg-background-100/80">
                  {/* Drum row */}
                  <div className="flex items-center gap-1.5">
                    {(() => {
                      const lvl = product.stockDrum >= 100 ? 'high' : product.stockDrum >= 30 ? 'medium' : 'low';
                      const dotColors = { high: 'bg-emerald-500', medium: 'bg-amber-500', low: 'bg-red-500' };
                      return <div className={`w-2 h-2 rounded-full ${dotColors[lvl]} flex-shrink-0`}></div>;
                    })()}
                    <span className="text-foreground-600 text-xs">
                      <span className="font-600 text-foreground-800">{product.stockDrum}</span> Tambores 208L
                    </span>
                  </div>
                  {/* Tote row */}
                  <div className="flex items-center gap-1.5">
                    {(() => {
                      const lvl = product.stockTote >= 25 ? 'high' : product.stockTote >= 8 ? 'medium' : 'low';
                      const dotColors = { high: 'bg-emerald-500', medium: 'bg-amber-500', low: 'bg-red-500' };
                      return <div className={`w-2 h-2 rounded-full ${dotColors[lvl]} flex-shrink-0`}></div>;
                    })()}
                    <span className="text-foreground-600 text-xs">
                      <span className="font-600 text-foreground-800">{product.stockTote}</span> Totem 1000L
                    </span>
                  </div>
                </div>

                <button
                  onClick={() => navigate('/contacto')}
                  className="w-full py-2.5 rounded-md border border-primary-500/40 text-primary-400 text-sm font-600 hover:bg-primary-500 hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  Solicitar Cotización
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}